import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title = "A1 Bakery & Sweets",
  description = "A1 Bakery & Sweets offers a wide range of delicious bakery products and traditional Indian sweets. Order online for fresh, high-quality treats delivered to your door.",
  keywords = "bakery, sweets, Indian sweets, cakes, pastries, snacks, online order, A1 Bakery, Madurai",
  ogTitle = "A1 Bakery & Sweets - Authentic Indian Delights & Fresh Bakes",
  ogUrl = window.location.href,
  ogImage = "/assets/img/a1-img/Logo.png", // Default logo image
  ogType = "website",
  ogDescription = "A1 Bakery & Sweets offers a wide range of delicious bakery products and traditional Indian sweets. Order online for fresh, high-quality treats delivered to your door.",
  twitterCard = "summary_large_image",
  twitterDomain = window.location.hostname,
  twitterUrl = window.location.href,
  twitterTitle = "A1 Bakery & Sweets - Authentic Indian Delights & Fresh Bakes",
  twitterDescription = "A1 Bakery & Sweets offers a wide range of delicious bakery products and traditional Indian sweets. Order online for fresh, high-quality treats delivered to your door.",
  twitterImage = "/assets/img/a1-img/Logo.png", // Default logo image
  canonical = window.location.href,
}) => {
  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook Meta Tags */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      <meta property="og:description" content={ogDescription} />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta property="twitter:domain" content={twitterDomain} />
      <meta property="twitter:url" content={twitterUrl} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={twitterImage} />
    </Helmet>
  );
};

export default SeoHelmet;
